<app-invite *transloco="let t">
  <app-main-header header noIcon>{{ t('create-account') }}</app-main-header>
  <app-header isBig title>{{ t('business-representative-invitation')}}</app-header>
  <app-paragraph instructions>
    {{ t('business-representative-invitation-content-1', { organization: businessName } )}}
  <br><br>
  {{ t('business-representative-invitation-content-2')}}
  </app-paragraph>
  <app-circle image size="small" isLight>group</app-circle>
  <div *ngIf="errorMsg" buttonSection>
    <app-label isError>
      {{ t(errorMsg) }}
    </app-label>
  </div>
  <div *ngIf="isRepresentativeNew === true" buttonSection>
    <app-primary-button id="lnr-invite-create-account" (clickAction)="redirectToCreateAccountPage()" stroked>
      {{ t('create-an-account') }}
    </app-primary-button>
  </div>
  <div *ngIf="isRepresentativeNew === false" buttonSection>
    <app-primary-button id="lnr-invite-login" (clickAction)="redirectToLogin()" stroked>
      {{ t('login') }}
    </app-primary-button>
  </div>
</app-invite>
